<template>
  <div class="container__class">
    <v-menu offset-y right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          text
          v-bind="attrs"
          v-on="on"
          right
          class="btn__class text-capitalize"
        >
          <span
            >{{ btnText }} <v-icon color="#2d8cff">mdi-menu-down</v-icon></span
          >
        </v-btn>
      </template>
      <v-list>
        <v-list-item-group v-model="selectedType">
          <v-list-item v-for="(item, i) in orderTypeList" :key="i">
            {{ item.name }}
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
// import { get } from "http";
export default {
  name: "OrderTypeComp",
  props: {
    value: { type: String, required: true },
    orderType: { type: String, required: true },
  },
  data() {
    return {
      orderTypeList: [
        { name: "Market Order", value: "MARKET" },
        { name: "Limit Order", value: "LIMIT" },
        // { name: "SLM", value: "SLM" },
        // { name: "SL", value: "SL" },
      ],
      selectedType: 0,
    };
  },
  computed: {
    btnText() {
      return this.orderTypeList[this.selectedType].name;
    },
    btnValue() {
      return this.orderTypeList[this.selectedType].value;
    },
    changeInValue: {
      get() {
        return this.orderType;
      },
    },
  },
  watch: {
    selectedType() {
      this.setValue();
    },
    changeInValue() {
      console.log("this is relflecting");
    },
  },
  methods: {
    setValue() {
      this.$emit("input", this.btnValue);
      // this.btnValue;
    },
    checkTheIndexAndValue() {
      for (const value in this.orderTypeList) {
        console.log(value, "jdjjdhjd");
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
.btn__class {
  height: 0px !important;
}
.btn__class >>> span {
  letter-spacing: 0px;
  color: #2d8cff;
}
.container__class {
  max-width: 45%;
}
</style>
